export default "__VITE_ASSET__etxzKu2s__"